exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fa-ul[data-v-550c01d4]{margin-left:2rem}.feature-list[data-v-550c01d4]{--tw-text-opacity:1;color:rgba(66,66,66,var(--tw-text-opacity));list-style-type:none}ul.feature-list li[data-v-550c01d4]{margin-bottom:.5rem}.tick-icon[data-v-550c01d4]{color:rgba(95,184,97,var(--tw-text-opacity))}.cross-icon[data-v-550c01d4],.tick-icon[data-v-550c01d4]{font-size:1rem;line-height:1.5rem;margin-right:.25rem;--tw-text-opacity:1}.cross-icon[data-v-550c01d4]{color:rgba(177,76,86,var(--tw-text-opacity))}", ""]);

// exports
